import React, { useState } from "react";
import { DateTimePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

function BasicDateTimePicker() {
	const [selectedDate, handleDateChange] = useState(new Date());

	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils} style={{ width: "100%" }}>
			<DateTimePicker
				inputVariant="outlined"
				value={selectedDate}
				onChange={handleDateChange}
				style={{ width: "100%" }}
			/>
		</MuiPickersUtilsProvider>
	);
}

export default BasicDateTimePicker;
